/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CardTransactionEvidenceWarnings
 */
export interface CardTransactionEvidenceWarnings {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceWarnings
     */
    'detectedDpi'?: CardTransactionEvidenceWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceWarnings
     */
    'calculatedDpi'?: CardTransactionEvidenceWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceWarnings
     */
    'colorGradation'?: CardTransactionEvidenceWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceWarnings
     */
    'heightMillis'?: CardTransactionEvidenceWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceWarnings
     */
    'widthMillis'?: CardTransactionEvidenceWarningsWidthMillisEnum;
}

export const CardTransactionEvidenceWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceWarningsDetectedDpiEnum = typeof CardTransactionEvidenceWarningsDetectedDpiEnum[keyof typeof CardTransactionEvidenceWarningsDetectedDpiEnum];
export const CardTransactionEvidenceWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceWarningsCalculatedDpiEnum = typeof CardTransactionEvidenceWarningsCalculatedDpiEnum[keyof typeof CardTransactionEvidenceWarningsCalculatedDpiEnum];
export const CardTransactionEvidenceWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionEvidenceWarningsColorGradationEnum = typeof CardTransactionEvidenceWarningsColorGradationEnum[keyof typeof CardTransactionEvidenceWarningsColorGradationEnum];
export const CardTransactionEvidenceWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceWarningsHeightMillisEnum = typeof CardTransactionEvidenceWarningsHeightMillisEnum[keyof typeof CardTransactionEvidenceWarningsHeightMillisEnum];
export const CardTransactionEvidenceWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceWarningsWidthMillisEnum = typeof CardTransactionEvidenceWarningsWidthMillisEnum[keyof typeof CardTransactionEvidenceWarningsWidthMillisEnum];


